import Consts from "Interfaces/Consts";


export default class Helper {
   
    static punctuationRegex = /[\u{5B0}\u{5B1}\u{5B2}\u{5B3}\u{5B4}\u{5B5}\u{5B6}\u{5B7}\u{5B8}\u{5B9}\u{5BB}\u{5BC}\u{5BD}\u{5BF}\u{5C1}\u{5C2}\u{5C4}\u{5C5}]/ug;


    static fetchData = (requestDetails) => {
        var jsonQuery = { id: Helper.toQueryId(requestDetails.queryId), CurrentPageId: Helper.toQueryId(requestDetails.pageId), Query: requestDetails.searchTerm, Skip: requestDetails.skip, Limit: requestDetails.limit, IncludedFilters: requestDetails.includedFilters };

        return fetch(requestDetails['API_URL'], {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonQuery)
        }).then(res => {
            if (!res.ok) {
                throw res;
            }
            return res.json();
        })
    }
    // Content/page ids arrive from HTML data-attributes as strings (often empty when unset);
    // the API models bind them as int, so coerce here rather than sending a bare/empty string.
    static toQueryId = (value): number => {
        const parsed = parseInt(value, 10);
        return Number.isNaN(parsed) ? 0 : parsed;
    }

    // For GetSummary endpoint - safe parsing of json
    static fetchAuthorizedData = (requestDetails) => {
        var jsonQuery = { id: Helper.toQueryId(requestDetails.queryId), CurrentPageId: Helper.toQueryId(requestDetails.pageId), Query: requestDetails.searchTerm, Skip: requestDetails.skip, Limit: requestDetails.limit, IncludedFilters: requestDetails.includedFilters };

        return fetch(requestDetails['API_URL'], {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(jsonQuery)
        })
            .then(res => {
                if (!res.ok) {
                    throw res;
                }
                return res.text();
            })
            .then(stringifiedJson => this.parseJsonSafely(stringifiedJson))
    }

    static parseJsonSafely = (stringifiedJSON) => {

        try { return JSON.parse(stringifiedJSON); }
        catch (err) { 
            
            for (let i = 0; i < stringifiedJSON.length; i++) {

                try { return JSON.parse(stringifiedJSON.slice(i)) }
                catch (e) { continue; }

            }
        }
    }

    static handleLinkClicksGA4 = (event, title, text) => {
        title = title == "" ? "Empty" : title;;
        if (typeof gtag === "function") {
            gtag('event', event, { 'element_text': title, 'item_text': text });
        }
    }
   
    static GA4OuterClickEvent = (links) => {
        for (let i = 0; i < links.length; i++) {
            links[i].addEventListener("click", function (e) {
                try {
                    var pressedLink = this.href.toLowerCase();
                    var siteDomain = location.protocol + '//' + location.host;
                    if (!pressedLink.startsWith(siteDomain) &&
                        (
                        pressedLink.startsWith("http") ||
                        pressedLink.startsWith("mailto:") ||
                        pressedLink.startsWith("tel:")
                    )) {
                        Helper.handleLinkClicksGA4('Outer_link_click', this.innerText, pressedLink);
                    }
                }
                catch (e) { }
            }, false);
        }
    }

    static ShortHtml = (htmlContent, length) => {
        try {
            if (htmlContent && htmlContent.length > length) {
                htmlContent = Helper.CleanHtmlTags(htmlContent);

                if (htmlContent.length > length) {

                    const lengthExtanded = length + this.getMaxPunctuationCount(htmlContent, length);

                    if (htmlContent.length > lengthExtanded) {
                        htmlContent = htmlContent.substring(0,
                            htmlContent.lastIndexOf(' ', lengthExtanded)) + "...";
                    }
                }
            }
        } catch (e) {

        }

        return htmlContent;
    }

    static CleanHtmlTags = (htmlContent) => {
        return htmlContent.replace(/<[^>]*>?/gm, '').replace("&nbsp;", "");
    }

    static ShortText = (content, length) => {
        try {
            if (content && content.length > length) {

                const lengthExtanded = length + this.getMaxPunctuationCount(content, length);

                if (content.length > lengthExtanded) {
                    content = content.substring(0,
                        content.lastIndexOf(' ', lengthExtanded)) + "...";
                }
            }
        } catch (e) {

        }

        return content;
    }

    static substringEx = (stringValue, end) => {

        if (stringValue) {
        const punctuationLength = this.getMaxPunctuationCount(stringValue, end);        
            return stringValue.substring(0, end + punctuationLength);
        }
        else {
            return "";
        }       
       
    }

    static getMaxPunctuationCount = (stringValue, maxLength) => {

        if (this.punctuationRegex.test(stringValue)) {
            const cleanLength = stringValue.replace(this.punctuationRegex, "").length;

            if (cleanLength <= maxLength) {
                // text without punctuation is shorter than max length
                return (stringValue.length - cleanLength);
            }

            // text without punctuation is longer than max length
            let shortString = stringValue.substring(0, maxLength);
            let punctuationOnShortString = (maxLength - shortString.replace(this.punctuationRegex, "").length);

            if (cleanLength > maxLength + punctuationOnShortString) {
                //calculate length again

                shortString = stringValue.substring(0, maxLength + punctuationOnShortString);
                //calculate again for a little more space, plus space from previous calculation
                punctuationOnShortString = (maxLength - shortString.replace(this.punctuationRegex, "").length) + punctuationOnShortString;

            }

            return punctuationOnShortString;
        }

        return 0;
    }

    static GetLanguageNativeName = (langAttribute) => {
        var languages = {
            'en': 'English',
            "ar": "العربية",
            "he": "עברית",
            "am": "አማርኛ",
            "zh": "中文",
            "fr": "Français",
            "de": "Deutch",
            "hi": "हिन्दी",
            "ja": "日本語",
            "ko": "한국어",
            "pt": "Português",
            "ro": "Românesc",
            "ru": "Русский",
            "es": "Español",
            "th": "ไทย",
            "uk": "Українська",
            "_en": "Filipino"
        };
        return languages[langAttribute];
    }


    static getDay = (date) => {
        const day = new Date(date).getUTCDate();
        return day;
    }
    static getMonth = (date) => {

        return new Date(date).toLocaleDateString(Consts.dateCulture, { month: 'short' })
    }

    static getMonthNumber = (date) => {      

        let monthNumber = new Date(date).getMonth();
        return monthNumber;
    }
    static getWeekDay = (date) => {
        return new Date(date).toLocaleDateString(Consts.dateCulture, { weekday: 'long', timeZone: 'UTC' })
    }
    static getYear = (date) => {
        const year = new Date(date).getFullYear();
        return year;
    }
    static getTime = (date) => {
       
       
        //let time = new Date(date).toLocaleDateString('he-IL', {
        //    year: "numeric",
        //    month: "numeric",
        //    day: "numeric",
        //    hour: "numeric",
        //    minute: "numeric",
        //    hour12: false
        //}).split(' ');
        let time = new Date(date).toUTCString();
        var hoursAndMinuts = time.split(' ')[4];
        var splitTitme = ""
       
        if (hoursAndMinuts) {         
            splitTitme = hoursAndMinuts.split(':')[0] + ":" + hoursAndMinuts.split(':')[1];
        }
       

        return splitTitme;
    }

    static getTimeValue = (date) => {
        return new Date(date).getTime()
    }

    static getLongMonth = (date) => {

        return new Date(date).toLocaleDateString(Consts.dateCulture, { month: 'long' })
    }

    static disableTabIndexOfHiddenContent = (content, isHide) => {
        const contentElementRect = content.getBoundingClientRect();
        const parentBottom = contentElementRect.bottom;

        content.querySelectorAll("a").forEach(
            element => {
                const elementRect = element.getBoundingClientRect();
                const elementBottom = elementRect.bottom;
                if (isHide) {                   
                    if (elementBottom > parentBottom) {
                        element.tabIndex = -1;
                        element["data-invisible"] = "true";

                    }
                }
                else {                    
                    if (elementBottom > parentBottom) {
                        element.tabIndex = 0;
                        element["data-invisible"] = "false";

                    }
                }
                
               
            }
        );
    }

    static convertServerMediaItemToMediaItem = (stringifiedMediaFromServer /* string | null */) => {

        let mediaItem = { alt: '', isImage: true, rectangleUrl: '', squareUrl: '', url: '', copyRight: '' };

        if (!!stringifiedMediaFromServer) {
            const serverImage = JSON.parse(stringifiedMediaFromServer);

            mediaItem = {
                url: serverImage.Url,
                alt: serverImage.Alt,
                isImage: serverImage.isImage,
                rectangleUrl: serverImage.RectangleImage,
                squareUrl: serverImage.SquareImage,
                copyRight: serverImage.CopyRight,
            }
        }

        return mediaItem;
    }

    static convertServerLinkItemToClientLinkItem = (stringifiedLink) => {

        const defaultLinkItem = { url: "", title: "", target: "#", name: "" };
        let linkItem = defaultLinkItem;
       
        if (!!stringifiedLink && stringifiedLink != "null") {
            const parsedServerLink = JSON.parse(stringifiedLink);           
            linkItem = {
                url: parsedServerLink.Url,
                title: parsedServerLink.Title,
                target: parsedServerLink.Target,
                name: parsedServerLink.Name
            };
        }
        return linkItem;
    }

    static getShadowColor = (shadowColor) => {
        var shadowType = {
            "בהיר": "Light",
            "כהה": "Dark",
            "צבע הפלטה": "Pallete"
           
        };
        return shadowType[shadowColor];
    }

    static getLinkTarget = (linkTarget) => {
        var target = {
            "By item configuration": "",
            "Open in new tab": "_blank",
            "Open in the same tab": "_self"
        };
        return linkTarget == "" ? "" : target[linkTarget];
    }

    static stringIsNullOrEmpty(text) {
        return text == null || text.length == 0;
    }

    static getAlignment = (alignmentValue) => {
        var value = {
            "ימין": "start",
            "מרכז": "center",
            "שמאל": "end"
        }
        return alignmentValue == "" ? "start" : value[alignmentValue];
    }
}